/* =====================================================================
   STICKERS PERSO - Fiche produit
   Galerie, choix des variantes, prix, barre d'achat
   mobile, et habillage des champs Infinite Options (pastilles couleur,
   vignettes drapeaux) : les selects de l'app restent dans le formulaire,
   ce sont eux qui partent au panier.
   ===================================================================== */
(function () {
  'use strict';

  /* ---------- Couleurs de vinyle (reprises de lettrage-velo) ---------- */
  var COLORS = {
    'blanc': ['#FFFFFF', 'gloss'],
    'noir': ['#0B0B0C', 'gloss'],
    'noir brillant': ['#060608', 'gloss'],
    'noir mat': ['#2C2D2F', 'matte'],
    'rouge': ['#D7262E', 'gloss'],
    'or': ['#C9A23F', 'metal'],
    'argent': ['#B5BAC1', 'metal'],
    'vert pomme': ['#79C143', 'gloss'],
    'vert': ['#0F6B3A', 'gloss'],
    'vert fonce': ['#0F6B3A', 'gloss'],
    'bleu ciel': ['#4FB3E8', 'gloss'],
    'bleu': ['#1B2F7A', 'gloss'],
    'bleu fonce': ['#1B2F7A', 'gloss'],
    'jaune': ['#EBDC00', 'gloss'],
    'orange': ['#ED5300', 'gloss'],
    'gris': ['#8E949C', 'gloss'],
    'gris anthracite': ['#3A3D42', 'gloss'],
    'anthracite': ['#3A3D42', 'gloss'],
    'gris anthracite paillete': ['#424440', 'metal'],
    'anthracite paillete': ['#424440', 'metal'],
    'fuschia': ['#E0218A', 'gloss'],
    'fuchsia': ['#E0218A', 'gloss'],
    'rose': ['#F5A3C7', 'gloss'],
    'bordeaux': ['#6A1B2B', 'gloss']
  };

  /* ---------- Drapeaux (reprises de lettrage-velo) : SVG en ligne ou fichier sp-flag-*.png ---------- */
  function tri(a, b, c, vertical) {
    return vertical
      ? '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="10" height="20" fill="' + a + '"/><rect x="10" width="10" height="20" fill="' + b + '"/><rect x="20" width="10" height="20" fill="' + c + '"/></svg>'
      : '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="30" height="7" fill="' + a + '"/><rect y="6.67" width="30" height="6.67" fill="' + b + '"/><rect y="13.33" width="30" height="6.67" fill="' + c + '"/></svg>';
  }
  var catalan = '<svg viewBox="0 0 30 20" preserveAspectRatio="none">';
  for (var s = 0; s < 9; s++) catalan += '<rect y="' + (s * 20 / 9).toFixed(2) + '" width="30" height="2.3" fill="' + (s % 2 ? '#DA121A' : '#FCDD09') + '"/>';
  catalan += '</svg>';
  var FLAGS = {
    'france': tri('#0055A4', '#fff', '#EF4135', true),
    'belgique': tri('#111', '#FDDA24', '#EF3340', true),
    'italie': tri('#009246', '#fff', '#CE2B37', true),
    'pays bas': tri('#AE1C28', '#fff', '#21468B'),
    'luxembourg': tri('#EF3340', '#fff', '#00A3E0'),
    'russie': tri('#fff', '#0039A6', '#D52B1E'),
    'allemagne': tri('#111', '#DD0000', '#FFCE00'),
    'espagne': '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="30" height="20" fill="#AA151B"/><rect y="5" width="30" height="10" fill="#F1BF00"/></svg>',
    'euskadi': '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="30" height="20" fill="#D52B1E"/><path d="M0 0L30 20M30 0L0 20" stroke="#009B48" stroke-width="3"/><path d="M15 0v20M0 10h30" stroke="#fff" stroke-width="2.6"/></svg>',
    'uk': '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="30" height="20" fill="#012169"/><path d="M0 0L30 20M30 0L0 20" stroke="#fff" stroke-width="4"/><path d="M0 0L30 20M30 0L0 20" stroke="#C8102E" stroke-width="1.4"/><path d="M15 0v20M0 10h30" stroke="#fff" stroke-width="6"/><path d="M15 0v20M0 10h30" stroke="#C8102E" stroke-width="3.4"/></svg>',
    'savoie': '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="30" height="20" fill="#D52B1E"/><path d="M15 0v20M0 10h30" stroke="#fff" stroke-width="4"/></svg>',
    'monaco': '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="30" height="10" fill="#CE1126"/><rect y="10" width="30" height="10" fill="#fff"/></svg>',
    'colombie': '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="30" height="10" fill="#FCD116"/><rect y="10" width="30" height="5" fill="#003893"/><rect y="15" width="30" height="5" fill="#CE1126"/></svg>',
    'catalan': catalan,
    'aucun drapeau': '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="30" height="20" fill="#F3F4F6"/><circle cx="15" cy="10" r="6" fill="none" stroke="#9CA3AF" stroke-width="1.6"/><path d="M10.8 14.2l8.4-8.4" stroke="#9CA3AF" stroke-width="1.6"/></svg>',
    'bretagne': '@bretagne', 'pirate': '@pirate', 'suisse': '@suisse', 'normandie': '@normandie',
    'lion des flandres': '@lion-des-flandres', 'occitanie': '@occitanie', 'corse': '@corse',
    'portugal': '@portugal', 'europe': '@europe', 'wallonie': '@wallonie', 'ile de france': '@ile-de-france',
    'alsace': '@alsace', 'canada': '@canada', 'vendee': '@vendee', 'arc en ciel': '@arc-en-ciel', 'la reunion': '@la-reunion'
  };
  var FLAG_ALIASES = { 'aucun drapeaux': 'aucun drapeau', 'aucun': 'aucun drapeau', 'pays-bas': 'pays bas', 'royaume uni': 'uk', 'royaume-uni': 'uk', 'flandres': 'lion des flandres', 'catalogne': 'catalan', 'reunion': 'la reunion' };

  function key(str) {
    return String(str || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  }
  function colorOf(name) { return COLORS[key(name)] || null; }
  function flagHTML(name, base) {
    var k = key(name);
    k = FLAG_ALIASES[k] || k;
    var f = FLAGS[k];
    if (!f) return '<svg viewBox="0 0 30 20" preserveAspectRatio="none"><rect width="30" height="20" fill="#e2ded6"/></svg>';
    if (f.charAt(0) === '@') return '<img src="' + base + 'sp-flag-' + f.slice(1) + '.png" alt="" width="42" height="28" loading="lazy" decoding="async">';
    return f;
  }

  /* ---------- Prix ---------- */
  function money(cents, format) {
    var fmt = String(format || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ').replace(/&euro;/g, '€').replace(/&amp;/g, '&');
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = cents / 100;
    function f(n, dec, th, ds) {
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return dec ? p.join(ds) : p[0];
    }
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = f(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = f(v, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = f(v, 0, '.', ','); break;
      case 'amount_with_space_separator': out = f(v, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': out = f(v, 2, "'", '.'); break;
      default: out = f(v, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  /* "4 paires identiques" -> { n: 4, noun: 'paire', art: 'la' } : sert au prix unitaire et a l'economie */
  var UNIT_NOUNS = { paire: 'la', kit: 'le', flamme: 'la', lettrage: 'le', lot: 'le', raclette: 'la', drapeau: 'le', planche: 'la' };
  function unitInfo(label) {
    var m = String(label || '').match(/^(\d+)\s+(\S+)/);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    var noun = m[2].toLowerCase().replace(/s$/, '');
    return n > 0 && UNIT_NOUNS[noun] ? { n: n, noun: noun, art: UNIT_NOUNS[noun] } : null;
  }

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-sp-track]');
    var api = { goToMedia: function () {} };
    if (!track) return api;
    var slides = [].slice.call(track.children);
    var thumbs = [].slice.call(root.querySelectorAll('[data-sp-thumb]'));
    var thumbsBox = thumbs.length ? thumbs[0].closest('ul') : null;
    var prev = root.querySelector('[data-sp-prev]');
    var next = root.querySelector('[data-sp-next]');
    var count = root.querySelector('[data-sp-count]');
    var idx = 0;

    function set(i) {
      idx = i;
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (count) count.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      var t = thumbs[i];
      if (t && thumbsBox) {
        var left = t.offsetLeft - (thumbsBox.clientWidth - t.offsetWidth) / 2;
        thumbsBox.scrollTo({ left: Math.max(0, left) });
      }
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth });
      set(i);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== idx) set(i);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    set(0);

    /* une fois la page chargee, on precharge les autres photos : defilement et miniatures instantanes */
    var warm = function () {
      [].forEach.call(track.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
    };
    if (document.readyState === 'complete') setTimeout(warm, 300);
    else window.addEventListener('load', function () { setTimeout(warm, 300); });

    api.goToMedia = function (id) {
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].getAttribute('data-media-id') === String(id)) { go(n); return; }
      }
    };

    return api;
  }

  /* ---------- Champs Infinite Options : pastilles, drapeaux, boutons ---------- */
  function enhanceSelect(sel, base) {
    if (sel.getAttribute('data-sp-done')) return;
    var field = sel.closest('[class*="spb-io-field"]') || sel.parentNode;
    var labelEl = field.querySelector('label');
    var k = key((labelEl ? labelEl.textContent : '') + ' ' + sel.name);
    var opts = [].slice.call(sel.options).filter(function (o) { return o.value !== ''; });
    var kind = null;
    if (/drapeau/.test(k)) kind = 'flag';
    else if (/couleur/.test(k)) {
      var hits = opts.filter(function (o) { return colorOf(o.text); }).length;
      if (opts.length && hits >= opts.length * 0.6) kind = 'color';
    } else if (opts.length >= 2 && opts.length <= 4 && opts.every(function (o) { return o.text.trim().length <= 14; })) kind = 'seg';
    if (!kind) return;
    sel.setAttribute('data-sp-done', '1');
    /* "Aucun drapeau" juste apres France (l'ordre du select d'origine ne change pas) */
    if (kind === 'flag') {
      var ai = -1, fi = -1;
      opts.forEach(function (o, n) {
        var kk = key(o.text);
        if (/^aucun/.test(kk)) ai = n;
        if (kk === 'france') fi = n;
      });
      if (ai > -1) {
        var none = opts.splice(ai, 1)[0];
        if (fi > ai) fi--;
        opts.splice(fi > -1 ? fi + 1 : 0, 0, none);
      }
    }

    var wrap = sel.closest('.spb-select') || sel;
    wrap.classList.add('sp-io-native');
    var group = document.createElement('div');
    group.className = kind === 'flag' ? 'sp-io-flags' : kind === 'color' ? 'sp-io-sws' : 'sp-io-seg';
    group.setAttribute('role', 'radiogroup');
    var valueSpan = null;
    if (labelEl) {
      if (!labelEl.id) labelEl.id = 'SpIo-' + Math.random().toString(36).slice(2, 9);
      group.setAttribute('aria-labelledby', labelEl.id);
      if (kind !== 'seg') {
        valueSpan = document.createElement('span');
        valueSpan.className = 'sp-io-value';
        labelEl.appendChild(valueSpan);
      }
    }
    var buttons = opts.map(function (o) {
      var name = o.text.trim();
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-label', name);
      b.title = name;
      b.setAttribute('data-value', o.value);
      if (kind === 'color') {
        var c = colorOf(name);
        b.className = 'sp-io-sw';
        var sw = document.createElement('span');
        sw.className = 'sp-sw ' + (c ? 'sp-sw--' + c[1] : 'sp-sw--none');
        if (c) sw.style.setProperty('--c', c[0]);
        b.appendChild(sw);
      } else if (kind === 'flag') {
        b.className = 'sp-io-flag';
        b.innerHTML = '<span class="sp-io-flag__img" aria-hidden="true">' + flagHTML(name, base) + '</span><span class="sp-io-flag__name"></span>';
        b.lastChild.textContent = name;
      } else {
        b.className = 'sp-val';
        b.innerHTML = '<span class="sp-val__name"></span>';
        b.firstChild.textContent = name;
      }
      b.addEventListener('click', function () {
        if (sel.value === o.value) return;
        sel.value = o.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      group.appendChild(b);
      return b;
    });
    group.addEventListener('keydown', function (e) {
      var dir = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!dir) return;
      e.preventDefault();
      var n = buttons.indexOf(document.activeElement);
      var b = buttons[(n + dir + buttons.length) % buttons.length];
      b.focus();
      b.click();
    });
    function sync() {
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-value') === sel.value;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      if (valueSpan) {
        var o = sel.options[sel.selectedIndex];
        valueSpan.textContent = o ? o.text.trim() : '';
      }
    }
    sel.addEventListener('change', sync);
    wrap.insertAdjacentElement('afterend', group);
    if (kind === 'flag' && opts.length > 12) {
      group.classList.add('is-collapsed');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'sp-io-more';
      more.setAttribute('aria-expanded', 'false');
      more.textContent = 'Voir les ' + opts.length + ' drapeaux';
      more.addEventListener('click', function () {
        var open = group.classList.toggle('is-collapsed') === false;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Réduire la liste' : 'Voir les ' + opts.length + ' drapeaux';
      });
      group.insertAdjacentElement('afterend', more);
    }
    sync();
  }

  function addCounter(input) {
    if (input.getAttribute('data-sp-count')) return;
    var max = input.maxLength;
    if (!(max > 0)) return;
    var field = input.closest('[class*="spb-io-field"]') || input.parentNode;
    var labelEl = field.querySelector('label');
    if (!labelEl) return;
    input.setAttribute('data-sp-count', '1');
    var c = document.createElement('span');
    c.className = 'sp-io-count';
    c.setAttribute('aria-hidden', 'true');
    labelEl.appendChild(c);
    function upd() {
      var n = input.value.length;
      c.textContent = n + '/' + max;
      c.classList.toggle('is-full', n >= max);
    }
    input.addEventListener('input', upd);
    upd();
  }

  /* l'app injecte ses champs apres le chargement (et peut remplacer le conteneur) :
     on surveille tout le formulaire */
  function initIO(root, base) {
    var scope = root.querySelector('[data-sp-form]') || root;
    var queued = false;
    function run() {
      queued = false;
      var box = scope.querySelector('#infiniteoptions-container');
      if (!box) return;
      [].forEach.call(box.querySelectorAll('select'), function (sel) { enhanceSelect(sel, base); });
      [].forEach.call(box.querySelectorAll('input[type="text"][maxlength], textarea[maxlength]'), addCounter);
    }
    run();
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(run, 30);
    }).observe(scope, { childList: true, subtree: true });
  }

  /* ---------- Fiche produit ---------- */
  function initProduct(root) {
    if (root.getAttribute('data-sp-init')) return;
    root.setAttribute('data-sp-init', '1');
    var json = root.querySelector('[data-sp-json]');
    if (!json) return;
    var data = JSON.parse(json.textContent);
    var variants = data.variants || [];
    var fmt = data.moneyFormat;
    var gallery = initGallery(root);

    var form = root.querySelector('[data-sp-form]');
    var idInput = root.querySelector('[data-sp-variant]');
    var sets = [].slice.call(root.querySelectorAll('[data-sp-option]'));
    var priceEl = root.querySelector('[data-sp-price]');
    var compareEl = root.querySelector('[data-sp-compare]');
    var compareVal = root.querySelector('[data-sp-compare-val]');
    var badge = root.querySelector('[data-sp-badge]');
    var atc = root.querySelector('[data-sp-atc]');
    var atcText = root.querySelector('[data-sp-atc-text]');
    var sticky = root.querySelector('[data-sp-sticky]');
    var stickyPrice = root.querySelector('[data-sp-sticky-price]');
    var stickyBtn = root.querySelector('[data-sp-sticky-btn]');
    var info = root.querySelector('.sp-prod__info');
    var saveEl = root.querySelector('[data-sp-save]');
    var stickySave = root.querySelector('[data-sp-sticky-save]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var busy = false;
    var lastSave = 0;
    var countRaf = 0;
    var lastNudge = 0;

    /* relance une animation CSS deja jouee */
    function replay(el, cls) {
      el.classList.remove(cls);
      void el.offsetWidth;
      el.classList.add(cls);
    }
    /* compteur anime du montant economise */
    function countTo(el, from, to) {
      cancelAnimationFrame(countRaf);
      if (reduce || from === to) { el.textContent = money(to, fmt); return; }
      var t0 = performance.now();
      (function step(now) {
        var k = Math.min(1, (now - t0) / 700);
        var e = 1 - Math.pow(1 - k, 3);
        el.textContent = money(Math.round(from + (to - from) * e), fmt);
        if (k < 1) countRaf = requestAnimationFrame(step);
      })(t0);
    }
    /* ligne d'economie sous le prix : montant economise sur le lot choisi,
       ou "Jusqu'a -X %" quand le plus petit lot est selectionne */
    function showSave(picked, tease, animate) {
      if (stickySave) {
        stickySave.hidden = !picked;
        if (picked) stickySave.textContent = '-' + picked.pct + ' %';
      }
      if (!saveEl) return;
      if (!picked && !tease) { saveEl.hidden = true; lastSave = 0; return; }
      var pctEl = saveEl.querySelector('[data-sp-save-pct]');
      var txtEl = saveEl.querySelector('[data-sp-save-txt]');
      saveEl.hidden = false;
      saveEl.classList.toggle('sp-save--tease', !picked);
      txtEl.textContent = '';
      if (picked) {
        pctEl.textContent = '-' + picked.pct + ' %';
        txtEl.appendChild(document.createTextNode('Vous économisez '));
        var amt = document.createElement('strong');
        txtEl.appendChild(amt);
        txtEl.appendChild(document.createTextNode(picked.single ? ' par rapport à l’achat à l’unité' : ' par rapport au plus petit lot'));
        countTo(amt, animate ? lastSave : picked.amount, picked.amount);
        lastSave = picked.amount;
        if (animate && picked.badge) replay(picked.badge, 'is-stamp');
      } else {
        lastSave = 0;
        pctEl.textContent = 'Jusqu’à -' + tease.pct + ' %';
        var go = document.createElement('button');
        go.type = 'button';
        go.className = 'sp-save__go';
        go.textContent = 'en prenant ' + tease.label.toLowerCase();
        go.addEventListener('click', function () {
          tease.input.checked = true;
          tease.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        txtEl.appendChild(go);
      }
      if (animate) replay(saveEl, 'is-pop');
    }
    /* petite impulsion sur le bouton quand le client choisit une option */
    function nudge() {
      if (!atc || atc.disabled || busy) return;
      var now = Date.now();
      if (now - lastNudge < 900) return;
      lastNudge = now;
      replay(atc, 'is-nudge');
    }

    function selected() {
      return sets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function find(opts) {
      for (var n = 0; n < variants.length; n++) {
        var v = variants[n], ok = true;
        for (var i = 0; i < opts.length; i++) if (v.o[i] !== opts[i]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function setLabel(available, ok) {
      var label = !ok ? 'Indisponible' : available ? 'Ajouter au panier' : 'Épuisé';
      if (atc && !busy) { atc.disabled = !available; atcText.textContent = label; }
      if (stickyBtn) { stickyBtn.disabled = !available; stickyBtn.textContent = available ? 'Ajouter' : label; }
    }
    function update(fromUser) {
      var opts = selected();
      var v = find(opts);
      var picked = null, tease = null;
      sets.forEach(function (fs, i) {
        var checked = fs.querySelector('input:checked');
        var lab = fs.querySelector('[data-sp-opt-value]');
        if (lab && checked) lab.textContent = checked.getAttribute('data-clean');
        var inputs = [].slice.call(fs.querySelectorAll('input'));
        var found = inputs.map(function (inp) {
          var o = opts.slice();
          o[i] = inp.value;
          var vv = find(o);
          inp.closest('.sp-val').classList.toggle('is-unavailable', !vv || !vv.a);
          return vv;
        });
        var first = found[0] ? found[0].p : null;
        var varies = found.some(function (vv) { return vv && vv.p !== first; });
        var cards = fs.classList.contains('sp-opt--cards');
        /* lots : prix unitaire de reference = celui du plus petit lot */
        var units = inputs.map(function (inp) { return cards ? unitInfo(inp.getAttribute('data-clean')) : null; });
        var base = null;
        units.forEach(function (u, n) {
          if (u && found[n] && (!base || u.n < base.n)) base = { n: u.n, unit: found[n].p / u.n };
        });
        var pcts = inputs.map(function (inp, n) {
          var u = units[n], vv = found[n];
          return u && vv && base && u.n > base.n ? Math.round((1 - vv.p / u.n / base.unit) * 100) : 0;
        });
        var best = -1;
        pcts.forEach(function (pc, n) { if (pc >= 1 && (best < 0 || pc > pcts[best])) best = n; });
        var checkedSaves = false;
        inputs.forEach(function (inp, n) {
          var lbl = inp.closest('.sp-val');
          var el = lbl.querySelector('[data-sp-val-price]');
          /* lots : remise + prix unitaire dans la ligne du lot (sous son nom), prix seul a droite */
          var meta = lbl.querySelector('[data-sp-val-meta]');
          var host = meta || el;
          var save = lbl.querySelector('.sp-val__save');
          if (!el) return;
          var vv = found[n];
          var oldEm = host.querySelector('em');
          if (!vv || (!varies && !cards)) { el.textContent = ''; if (save) save.remove(); if (oldEm) oldEm.remove(); return; }
          var unit = units[n];
          var pct = pcts[n];
          if (meta) el.textContent = money(vv.p, fmt);
          else { el.innerHTML = ''; el.appendChild(document.createTextNode(money(vv.p, fmt))); oldEm = null; }
          if (unit && unit.n > 1) {
            var em = oldEm || document.createElement('em');
            em.textContent = 'soit ' + money(Math.round(vv.p / unit.n), fmt) + ' ' + unit.art + ' ' + unit.noun;
            if (!em.parentNode) host.appendChild(em);
          } else if (oldEm) oldEm.remove();
          if (pct >= 1) {
            if (!save) {
              save = document.createElement('span');
              save.className = 'sp-val__save';
              save.style.setProperty('--sp-d', (n * 90) + 'ms');
              if (meta) meta.insertBefore(save, meta.firstChild);
              else lbl.appendChild(save);
            }
            var label = (n === best ? 'Meilleur prix · ' : '') + '-' + pct + ' %';
            if (save.textContent !== label) save.textContent = label;
            save.classList.toggle('is-best', n === best);
          } else if (save) save.remove();
          if (inp.checked && pct >= 1 && !picked) {
            checkedSaves = true;
            picked = { pct: pct, amount: Math.round(base.unit * unit.n - vv.p), single: base.n === 1, badge: save };
          }
        });
        if (best > -1 && !checkedSaves && !tease && !picked) {
          tease = { pct: pcts[best], label: inputs[best].getAttribute('data-clean'), input: inputs[best] };
        }
      });
      showSave(picked, tease, fromUser);
      if (!v) { setLabel(false, false); return; }
      idInput.value = v.id;
      var txt = money(v.p, fmt);
      if (priceEl.textContent !== txt) {
        priceEl.textContent = txt;
        if (fromUser) {
          priceEl.classList.remove('is-bump');
          void priceEl.offsetWidth;
          priceEl.classList.add('is-bump');
        }
      }
      if (stickyPrice) stickyPrice.textContent = txt;
      var sale = v.c > v.p;
      if (compareEl) compareEl.hidden = !sale;
      if (compareVal && sale) compareVal.textContent = money(v.c, fmt);
      if (badge) {
        badge.hidden = !sale;
        if (sale) badge.innerHTML = '-' + Math.round((v.c - v.p) * 100 / v.c) + '&nbsp;%';
      }
      setLabel(v.a, true);
      if (fromUser) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
        if (v.m) gallery.goToMedia(v.m);
      }
    }
    sets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); nudge(); }); });
    update(false);

    /* retour visuel de l'ajout : le tiroir panier (theme.liquid) s'ouvre quand l'ajout a reussi */
    var timer = null;
    function resetAtc() {
      busy = false;
      atc.classList.remove('is-loading', 'is-added');
      update(false);
    }
    if (form && atc) {
      form.addEventListener('submit', function () {
        if (atc.disabled) return;
        busy = true;
        atc.classList.add('is-loading');
        atcText.textContent = 'Ajout…';
        clearTimeout(timer);
        timer = setTimeout(resetAtc, 5000);
      });
      /* champs de l'app (drapeau, couleur...) : meme impulsion */
      form.addEventListener('change', function (e) { if (e.target.tagName === 'SELECT') nudge(); });
      /* onde au clic */
      [atc, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.addEventListener('pointerdown', function (e) {
          if (reduce || b.disabled) return;
          var r = b.getBoundingClientRect();
          var dot = document.createElement('span');
          dot.className = 'sp-ripple';
          dot.style.left = (e.clientX - r.left) + 'px';
          dot.style.top = (e.clientY - r.top) + 'px';
          b.appendChild(dot);
          dot.addEventListener('animationend', function () { dot.remove(); });
        });
      });
      var drawer = document.getElementById('lv-drawer');
      if (drawer && 'MutationObserver' in window) {
        new MutationObserver(function () {
          if (drawer.classList.contains('open') && atc.classList.contains('is-loading')) {
            atc.classList.remove('is-loading');
            atc.classList.add('is-added');
            atcText.textContent = 'Ajouté au panier';
            clearTimeout(timer);
            timer = setTimeout(resetAtc, 2200);
          }
        }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    /* barre d'achat mobile */
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      }).observe(atc.closest('.sp-buy') || atc);
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }

    /* panneau colle au defilement seulement s'il tient dans l'ecran */
    if (info) {
      var check = function () {
        var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sp-header-h'), 10) || 72;
        var fits = info.offsetHeight < window.innerHeight - headerH - 40;
        info.classList.toggle('is-sticky', window.innerWidth >= 900 && fits);
      };
      check();
      window.addEventListener('resize', check, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(check).observe(info);
    }

    /* avis : defilement doux vers le widget Judge.me */
    [].forEach.call(root.querySelectorAll('a[href="#sp-avis"]'), function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('sp-avis');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ block: 'start' });
      });
    });

    initIO(root, data.flagBase || '');
  }

  function init(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-sp-product]'), initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* couleurs des pastilles de variantes Shopify (rendu Liquid) */
  function paint(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-sp-color]'), function (el) {
      var c = colorOf(el.getAttribute('data-sp-color'));
      el.classList.add(c ? 'sp-sw--' + c[1] : 'sp-sw--none');
      if (c) el.style.setProperty('--c', c[0]);
    });
  }
  paint();
  document.addEventListener('shopify:section:load', function (e) { paint(e.target); });
})();
